export const backNextLanguageContent = {
    'back': {
        'en': 'Back',
        'ar': 'خلف',
        'ht': 'Retounen',
        'pl': 'Z powrotem',
        'pt': 'Voltar',
        'sr': 'Назад',
        'es': 'Atrás',
        'vi': 'Mặt sau',
        'zh': '后退',
        'ne': 'पछाडि'
    },
    'next': {
        'en': 'Next',
        'ar': 'التالي',
        'ht': 'Next',
        'pl': 'Następny',
        'pt': 'Próximo',
        'sr': 'Следећи',
        'es': 'Próximo',
        'vi': 'Kế tiếp',
        'zh': '下一个',
        'ne': 'अर्को'
    },
    'begin': {
        'en': 'Begin',
        'ar': 'يبدأ',
        'ht': 'Kòmanse',
        'pl': 'Zaczynać',
        'pt': 'Começar',
        'sr': 'Започети',
        'es': 'Comenzar',
        'vi': 'Bắt đầu',
        'zh': '开始',
        'ne': 'सुरु गर्नुहोस्'
    },
    'options': {
        'en': 'Options',
        'ar': 'خيارات',
        'ht': 'Opsyon',
        'pl': 'Opcje',
        'pt': 'Opções',
        'sr': 'Опције',
        'es': 'Opciones',
        'vi': 'Tùy chọn',
        'zh': '选项',
        'ne': 'विकल्पहरू'
    },
    'add-more': {
        'en': 'Add More',
        'ar': 'أضف المزيد',
        'ht': 'Ajoute plis',
        'pl': 'Dodaj więcej',
        'pt': 'Adicione mais',
        'sr': 'Додај још',
        'es': 'Añadir más',
        'vi': 'Bổ sung thêm',
        'zh': '添加更多',
        'ne': 'अझै थप'
    },
    'done': {
        'en': 'Done',
        'ar': 'منتهي',
        'ht': 'Fè',
        'pl': 'Zrobione',
        'pt': 'Feito',
        'sr': 'Готово',
        'es': 'Hecho',
        'vi': 'Xong',
        'zh': '完毕',
        'ne': 'सकियो'
    },
    'close': {
        'en': 'Close',
        'ar': 'يغلق',
        'ht': 'Fèmen',
        'pl': 'Zamknąć',
        'pt': 'Fechar',
        'sr': 'Близу',
        'es': 'Cerca',
        'vi': 'Đóng',
        'zh': '关闭',
        'ne': 'बन्द गर्नुहोस्'
    },
    'thankyou': {
        'en': 'Thank You!',
        'ar': 'شكرًا لك!',
        'ht': 'Mèsi!',
        'pl': 'Dziękuję!',
        'pt': 'Obrigado!',
        'sr': 'Хвала вам!',
        'es': '¡Gracias!',
        'vi': 'Cảm ơn!',
        'zh': '谢谢你！',
        'ne': 'धन्यवाद!'
    },
}